export default __webpack_public_path__ + "static/spot-heart__core-360-free-05-web-85a8dec5da442ff4697aa75eb50cdaf6.jpg";